import { render, staticRenderFns } from "./EntityDetailedCardViewForPublic.vue?vue&type=template&id=87db022c&scoped=true"
import script from "./EntityDetailedCardViewForPublic.vue?vue&type=script&lang=js"
export * from "./EntityDetailedCardViewForPublic.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailedCardViewForPublic.vue?vue&type=style&index=0&id=87db022c&prod&lang=scss&scoped=true"
import style1 from "./EntityDetailedCardViewForPublic.vue?vue&type=style&index=1&id=87db022c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db022c",
  null
  
)

export default component.exports